var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPsb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 26,
    viewBox: "0 0 75 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3673 0.974609L7.78906 9.29312H15.3673V25.9294L22.9462 17.6309V0.974609H15.3673Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78984 25.9294L15.3687 17.6109H7.78984V0.974609L0.210938 9.27311V25.9294H7.78984Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.528 21.7706H34.5065V8.8771H40.5691V21.7706H44.5476V5.13429H30.5273V21.7713L30.528 21.7706ZM69.1766 11.3676H65.7774V8.8771H73.3468V5.13355H61.7982V21.7706C61.7982 21.7706 67.474 21.7706 69.3657 21.7706C72.3996 21.7706 74.6735 20.1011 74.6735 16.5687C74.6735 13.0364 72.3996 11.3676 69.1766 11.3676ZM68.7979 18.236H65.7781V14.9118H68.7979C69.7363 14.9118 70.6869 15.3179 70.6869 16.5695C70.6869 17.821 69.7363 18.236 68.7979 18.236ZM54.2868 18.2256C51.6316 18.2256 50.1382 16.0885 50.1382 13.4469C50.1382 11.3261 51.2252 8.66369 54.2112 8.66369C56.0752 8.66369 57.2776 9.9145 57.7043 10.4969L60.1239 7.84117C58.6643 5.92938 56.4729 4.71191 54.0222 4.71191C49.6272 4.71191 46.1591 8.28207 46.1591 13.4461C46.1591 18.2701 49.6272 22.1803 54.0222 22.1803C56.6531 22.1803 58.985 20.7776 60.4338 18.6176L57.9987 15.9448C57.2283 17.269 55.9713 18.2241 54.2862 18.2241",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPsb);
export default __webpack_public_path__ + "static/media/logo-psb.f9d14c09d5a955287e8f0ab07a3cad3d.svg";
export { ForwardRef as ReactComponent };